import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {ToggleButton, ToggleButtonGroup} from "react-bootstrap";
import ConditionalRender from "./ConditionalRender";

const ToggleButtons = (props) => {

    if(!props.buttons)
    {
        console.warn("Expected buttons but got null");
        return null;
    }

    return (
        <ToggleButtonGroup {...props} name="toggle-buttons" defaultValue={props.defaultValue ? props.defaultValue : props.buttons[0].value} onChange={props.onChange} value={props.value ? props.value : undefined} >
            {props.buttons.map((btn, i) => {
                return (
                    <ToggleButton 
                        key={i}
                        value={btn.value}
                        variant={btn.variant ? btn.variant : 'light'} 
                        id={`tbg-radio-${i}`} 
                        size={btn.size ? btn.size : "sm"}>
                            <div>
                                <ConditionalRender condition={btn.icon}>
                                    <FontAwesomeIcon icon={btn.icon}/>
                                </ConditionalRender>
                                <ConditionalRender condition={btn.text}>
                                    <span>{btn.text}</span>
                                </ConditionalRender>
                            </div>

                    </ToggleButton>
                )
            })}
        </ToggleButtonGroup>
    );
};

export default ToggleButtons;